export default __webpack_public_path__ + "static/media/homelogo2.68272390.png";